var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.showSpinnerLayer
    ? _c(
        "div",
        { staticClass: "search-view-container" },
        [
          _c(
            "LfHeaderTitleComponent",
            {
              staticClass: "header",
              attrs: { title: _vm.$t("views.search.search_results") },
            },
            [
              _c("LfLabelButtonComponent", {
                staticClass: "button",
                attrs: {
                  text: _vm.$t("action_buttons.close"),
                  action: () => _vm.returnToUrl(),
                  variant: "outlined",
                },
              }),
            ],
            1
          ),
          _vm.searchIsFinished
            ? [
                _c("TabsComponent", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.existsSomeResultToRender,
                      expression: "existsSomeResultToRender",
                    },
                  ],
                  key: _vm.componentKey,
                  ref: "tabComponent",
                  staticClass: "tabs-other-styles search-tabs",
                  attrs: {
                    tabs: _vm.tabsWithTotalsIncluded,
                    context: _vm.context,
                    allDataLoaded: _vm.everythingLoaded,
                    selectedTab: Number(_vm.currentTabInfo.index),
                  },
                  on: {
                    "changed-tab": _vm.getSearchListData,
                    "set-tandem-filter": _vm.setTandemFilter,
                  },
                }),
                _c("NoResultsComponent", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.existsSomeResultToRender,
                      expression: "!existsSomeResultToRender",
                    },
                  ],
                }),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }